export default __webpack_public_path__ + "static/media/Tom.63c7bbd3.jpg";